import { AuthConfig as LibConfig } from 'angular-oauth2-oidc';
import { AuthConfig } from "@spartacus/core";
import { INITIAL_CONFIG } from 'app/utils/consts';
import { environment } from 'environments/environment';


export const slbAuthConfig = (configurations: { code: string, value: string }[]): AuthConfig => {
    return {
        authentication: {
            client_id: configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_DELFI_CLIENT_ID)?.value,
            client_secret: configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_AUTH_CLIENT_SECRET)?.value,
            baseUrl: configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_URL_DELFI)?.value,
            loginUrl: `${environment.authConfig.loginUrl}`,
            logoutUrl: `${environment.authConfig.logoutUrl}`,
            OAuthLibConfig: {
                scope: INITIAL_CONFIG.SPA_AUTH_SCOPE,
                redirectUri: `${configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_URL_ENVIRONMENT)?.value}/callback`,
                responseType: INITIAL_CONFIG.SPA_AUTH_RESPONSE_TYPE,
                preserveRequestedRoute: true,
                requestAccessToken: false,
                oidc: true,
                tokenEndpoint: `${configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_API_URL)?.value}/authorizationserver/oauth/token`,
                revocationEndpoint: `${configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_API_URL)?.value}/authorizationserver/oauth/revoke`,
                customQueryParams: {
                    clientId: configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_AUTH_CLIENT_ID)?.value,
                    grant_type: INITIAL_CONFIG.SPA_AUTH_GRANT_TYPE,
                    site: INITIAL_CONFIG.SPA_BASE_SITE,
                    apiEndpoint: `${configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_API_URL)?.value}`,
                    redirectUri: `${configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_URL_ENVIRONMENT)?.value}`
                }
            } as LibConfig
        }
    }
}